import { forwardRef } from 'react';
import { FormErrorBanner } from '~/components/shared/forms';

export interface IAuthErrorBannerProps {
  visible: boolean;
  /** Single message or list of messages. When multiple, each renders on its own line. */
  message?: string | string[];
  /** Prefix rendered before the message. Pass an empty string to omit. @default 'Oops!' */
  prefix?: string;
}

/**
 * Thin wrapper around FormErrorBanner that preserves the `auth-error-banner`
 * data-testid relied on by AuthRedesign tests.
 *
 * Maps the legacy `prefix` prop to FormErrorBanner's `title` prop.
 */
export const AuthErrorBanner = forwardRef<HTMLDivElement, IAuthErrorBannerProps>(
  ({ prefix, ...props }, ref) => (
    <FormErrorBanner
      ref={ref}
      data-testid="auth-error-banner"
      title={prefix}
      ribbonStyle={{ padding: 0 }}
      {...props}
    />
  ),
);

AuthErrorBanner.displayName = 'AuthErrorBanner';
